<template>
    <div id="app">
        <div class="wrapper" v-if="isConnected">
            <header class="main-header">
                <a href="#" class="logo">
                    <span class="logo-mini"><b>T</b>R</span>
                    <span class="logo-lg"><b>Pam</b> Rapprochement</span>
                </a>
                <nav class="navbar navbar-static-top" role="navigation">
                    <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
                        <span class="sr-only">Toggle navigation</span>
                    </a>
                    <div class="navbar-custom-menu">
                        <ul class="nav navbar-nav">
                            <li class="dropdown user user-menu">
                                <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                                    <span class="hidden-xs">{{getUserFullname}}</span>
                                </a>
                                <ul class="dropdown-menu">
                                    <!-- The user image in the menu -->
                                    <li class="user-header">
                                        <p>
                                            {{getUserFullname}}
                                            <small>[Infos Utilisateur]</small>
                                        </p>
                                    </li>
                                    <!-- Menu Footer-->
                                    <li class="user-footer">
                                        <div class="pull-left">
                                            <a href="#" class="btn btn-default btn-flat">{{$t("PROFILE")}}</a>
                                        </div>
                                        <div class="pull-right">
                                            <a href="#" @click.prevent="logout()"
                                               class="btn btn-default btn-flat">{{$t("LOGOUT")}}</a>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>
            </header>
            <aside class="main-sidebar">
                <sideBarComponent></sideBarComponent>
            </aside>
            <div class="content-wrapper">
                <router-view></router-view>
            </div>
            <footer class="main-footer">
                <div class="pull-right hidden-xs">
                    Transdev
                </div>
                Pam Rapprochement
            </footer>

        </div>
        <loginComponent v-if="!isConnected && !isDev"></loginComponent>
        <loginComponentDev v-if="!isConnected && isDev"></loginComponentDev>

    </div>
</template>

<script>
    import sideBarComponent from './components/layout/sidebar.vue'
    import loginComponent from './components/pages/login'
    import loginComponentDev from './components/pages/logindev'
    import storeAuth from './stores/auth'
    import localStorage from 'localStorage'
    import Vue from 'vue'
    import api from './resources/apiProvider'

    export default {
        name: 'app',
       components: {sideBarComponent, loginComponent, loginComponentDev},
        store: {
            storeAuth
        },
        data() {
            return {}
        },
        created() {

        },
        computed: {
            isConnected() {
                return this.$store.storeAuth.getters.isConnected
            },
            getUserFullname() {
                return this.$store.storeAuth.getters.getFullName
            },
            isDev() {
                console.log(process.env)
                return process.env.NODE_ENV === 'development'
            }
        },
        methods: {
            logout() {
                this.$store.storeAuth.dispatch("resetStore")
                localStorage.clear()
                this.openLogoutPopUpWindow()
            },
            openLogoutPopUpWindow () {
                const url = process.env.VUE_APP_ROOT_API + '/' + api.getResourceUri().auth.logout
                const width = 1000
                const height = 650
                const top = (window.outerHeight - height) / 2
                const left = (window.outerWidth - width) / 2
                window.open(url,
                    'facebook_login',
                    'width=' + width + ',height=' + height + ',scrollbars=0,top=' + top + ',left=' + left)
            }
        },

    }
</script>

<style lang="scss">
    @import "./assets/scss/styles";
</style>
